module.exports = __webpack_public_path__ + "img/step5-en.de5a52b8.webp";